import { Action, combineReducers, createFeature } from "@ngrx/store";
import * as fromMesRemboursementsRecherche from '@features/mes-remboursements/store/search/search.reducers'
import * as fromMesRemboursements from '@features/mes-remboursements/store/remboursements/mes-remboursements.reducers'

export const MES_REMBOURSEMENTS_FEATURE = 'mesPaiementsPage';

export interface MesRemboursementsState {
  [fromMesRemboursementsRecherche.REMBOURSEMENT_RECHERCHE_FEATURE_KEY]: fromMesRemboursementsRecherche.MesRemboursementsRechercheFormState;
  [fromMesRemboursements.MES_REMBOURSEMENT_FEATURE_KEY]: fromMesRemboursements.DossierRemboursementState;
}

export interface State {
  [MES_REMBOURSEMENTS_FEATURE]: MesRemboursementsState;
}

export const demandeRemboursementReducers = (state: MesRemboursementsState | undefined, action: Action) =>
  combineReducers({
    [fromMesRemboursementsRecherche.REMBOURSEMENT_RECHERCHE_FEATURE_KEY]: fromMesRemboursementsRecherche.reducer,
    [fromMesRemboursements.MES_REMBOURSEMENT_FEATURE_KEY]: fromMesRemboursements.reducer,
  })(state, action);


export const mesRemboursementsFeature = createFeature({
  name: MES_REMBOURSEMENTS_FEATURE,
  reducer: demandeRemboursementReducers
});
